var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBicycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1055 5.75391H22.0408",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 5.80469L20.3397 17.2825",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9762 17.6367C12.9762 19.4895 11.4884 20.9995 9.64239 20.9995C7.7964 20.9995 6.30859 19.4987 6.30859 17.6367",
    fill: "#FFDD02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9762 17.6367C12.9762 19.4895 11.4884 20.9995 9.64239 20.9995C7.7964 20.9995 6.30859 19.4987 6.30859 17.6367",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0508 5.75391L23.309 14.2951",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6445 8.22266H24.3711",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3329 17.6016H5.23438",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6658 20.999C25.507 20.999 26.9996 19.4934 26.9996 17.6362C26.9996 15.779 25.507 14.2734 23.6658 14.2734C21.8246 14.2734 20.332 15.779 20.332 17.6362C20.332 19.4934 21.8246 20.999 23.6658 20.999Z",
    fill: "#FFDD02",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21757 9.55048H3.25926C2.01024 9.55048 1 8.53147 1 7.27159V3.27889C1 2.01902 2.01024 1 3.25926 1H7.21757C8.46659 1 9.47683 2.01902 9.47683 3.27889V7.27159C9.47683 8.53147 8.46659 9.55048 7.21757 9.55048Z",
    fill: "#FFDD02",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6465 17.6018L12.4883 13.0625",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23466 17.6027C5.23466 17.6027 5.12445 13.0078 9.27562 13.0078",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7545 13.0154H3.74609V9.55078H11.7545C12.7005 9.55078 13.4719 10.3289 13.4719 11.2831C13.4719 12.2373 12.7005 13.0154 11.7545 13.0154Z",
    fill: "#FFDD02",
    stroke: "#212121",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBicycle);
export default __webpack_public_path__ + "static/media/icon-bicycle.5f2560fe.svg";
export { ForwardRef as ReactComponent };